import React, { useState, useEffect, useRef } from "react";

import '../../App.css';
import "../../assets/css/superadmin/superadmin.css";
import Header from "../../Components/Header/Header";
import LeftMenu from "../../Components/LeftMenu/LeftMenu";

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faBox, faHouseUser, faPlus, faEye, faUser } from '@fortawesome/free-solid-svg-icons';
import { Button, Dropdown, Modal, Form, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { setRedirecting } from "../../App";
import { withoutRFSToken, withRFSToken } from '../../Services/axios';
import dnata_handeler_icon from "../../assets/images/superadmin/dnata_handeler_icon.png";
import search_icon from "../../assets/images/superadmin/search_icon.png";
import station_icon from "../../assets/images/superadmin/warehouse.png";
import switch_icon from "../../assets/images/superadmin/switch_icon.png";
import { SLOTPLANNINGWAREHOUSE, ORGANIZATIONSTATIONADDEDIT, GETDESTINATION, SLOTPLANNINGWAREHOUSEADDEDIT, SLOTPLANNINGWAREHOUSEDELETERESTORE, SLOTPLANNINGWAREHOUSEACTIVEDEACTIVE } from '../../Utils/conts.js';
import Trash from "../../assets/images/trash.png";
import Edit from "../../assets/images/edit.png";
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import { decrypt } from "../../Utils/cryptoStorage.js";
import { useUserCheckQuery } from "../../redux/services/Auth.js";
const HandlerAdmin = () => {
    const [showHideAddWareHouse, setShowHideAddWareHouse] = useState(false);
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [allStationData, setAllStationData] = useState([]);
    const [stationData, setStationData] = useState([]);
    const [confModal, setConfModal] = useState(false);
    const [addStationModal, setAddStationModal] = useState(false);
    const tokenTypes = ['airlinetoken', 'forwardertoken', 'email_approval_token'];
    const userType = localStorage.getItem('User');
    // const orgType = localStorage.getItem('OrgType');
    // const Email = localStorage.getItem('Email');
    // const Phone = localStorage.getItem('Phone');
    // const Portal = localStorage.getItem('portal');
    // const loginFrom = localStorage.getItem('login_from');
    const [deleteId, setDeleteId] = useState();
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({});
    const [warehouseData, setWarehouseData] = useState({});
    const [selectedwarehouseData, setSelectedWarehouseData] = useState();
    const [warehouselist, setWarehouselist] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [selectedOrigin, setSelectedOrigin] = useState([]);
    const [authData, setAuthData] = useState();
    const [userDetails, setUserDetails] = useState();

    const loadStation = async () => {
        // setIsLoading(true);
        try {
            const res = await withRFSToken.get('organization-station/list')
                .then(function (res) {
                    const innerData = res.data.response_data;

                    if (innerData.length == 1) {
                        localStorage.setItem('Handler_stn', JSON.stringify(innerData[0]));
                        window.location.replace('/Dashboard')
                    } else {
                        localStorage.setItem('Handler_stn', JSON.stringify(innerData));
                        // window.location.replace('/HandlerAdmin')
                        setAllStationData(innerData)
                        setStationData(innerData)
                        setIsLoading(false);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const ExtractSession = async () => {
        try {
            const encryptedData = sessionStorage.getItem('__A-');
            if (encryptedData) {
                const data = await decrypt(encryptedData);
                setAuthData(data);
            }
        } catch (error) {
            console.error("Session decrypt error:", error);
        } finally {
            // setAuthLoading(false);
        }
    };

    const { data: myData } = useUserCheckQuery('', {
        // skip: pageDetails.pagesize === 0,
    });
    useEffect(() => {
        if (myData?.response_data) {
            setUserDetails(myData?.response_data);
        }
    }, [myData]);

    useEffect(() => {
        if (isMounted.current) return;
        localStorage.removeItem('Handler_stn')
        loadStation();
        fetchDestination();
        ExtractSession();
        isMounted.current = true;
    }, []);

    const handleSearch = (e) => {
        const value = e.target.value;

        if (!value) {
            setStationData(allStationData);
            return;
        }

        const filtered = allStationData.filter((item) =>
            item.station_name.toLowerCase().startsWith(value.toLowerCase())
        );

        setStationData(filtered);
    };

    const handleSwitch = (data) => {
        localStorage.removeItem('Handler_stn');
        localStorage.setItem('Handler_stn', JSON.stringify(data));
        window.location.replace('/Dashboard')
    }
    const handleUser = (data) => {
        localStorage.removeItem('Handler_stn');
        localStorage.setItem('Handler_stn', JSON.stringify(data));
        window.location.replace('/UserSettings')
    }

    const createWarehouse = (data) => {
        setModalShow(true);
        setModalData(data);
        fetchWareHouseData(data.org_station_id);
        setShowHideAddWareHouse(false);
        setSelectedWarehouseData(data.org_station_id);
        setWarehouseData({
            'warehouse_name': "",
            'warehouse_type': "",
            'name_contains': "",
        });
    }

    const fetchWareHouseData = async (org_station_id) => {
        try {
            const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: org_station_id, type: "all" });
            if (res.data.response_code == 200) {
                const innerData = res.data.response_data;
                setWarehouselist(innerData);
            }
        } catch (error) {
            console.error('Error fetching warehouse data:', error);
        }
    };

    const modalClose = () => { setModalShow(false); }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setWarehouseData({ ...warehouseData, [name]: value });
    }

    const addWarehouse = async () => {
        const payload = { ...warehouseData, org_station_id: modalData.org_station_id, station_id: modalData.station_id }
        try {
            const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEADDEDIT, payload)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        fetchWareHouseData(selectedwarehouseData);
                        setShowHideAddWareHouse(false)
                    } else {
                        toast.error(res.data.response_msg);
                    } setModalShow(false)
                    loadStation()
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const addWareHouseShowHide = async (status) => {
        setShowHideAddWareHouse(status);
    }

    const handleConfirmation = (confirm) => {
        if (confirm) {
            handleDoorDelete(deleteId)
            setConfModal(false);
        } else {
            setDeleteId(0);
            closeConfirm();
        }
    }

    const closeConfirm = () => {
        setConfModal(false);
    }

    const handleDoorDelete = async (commentId) => {
        const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEDELETERESTORE, { 'warehouse_id': deleteId })
        if (res.data.response_code == 200) {
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                closeConfirm();
                fetchWareHouseData(selectedwarehouseData);
                setShowHideAddWareHouse(false)
            } else {
                toast.error(res.data.response_msg);
            }
        } else {
            toast.error(res.data.response_msg);
        }
    }

    const editWarehouse = async (editId) => {
        warehouselist.forEach(element => {
            if (element.id == editId) {
                setWarehouseData({
                    'warehouse_name': element.name,
                    'warehouse_type': element.warehouse_type,
                    'name_contains': element.name_contains,
                    'warehouse_id': element.id,
                    'address_contains': element.address_contains,
                });

            }
        });
        setShowHideAddWareHouse(true);
    }

    const deleteWarehouse = async (editId) => {
        setConfModal(true);
        setDeleteId(editId);
    }
    const handleSwitchChange = async (checked, id) => {
        const newStatus = checked ? 1 : 0;
        const res = await withRFSToken.post('warehouse/warehouse-status', { warehouse_id: id, action: newStatus })
        if (res.data.response_code == 200) {
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                fetchWareHouseData(selectedwarehouseData);

            } else {
                toast.error(res.data.response_msg);
            }
        } else {
            toast.error(res.data.response_msg);
        }
        // try {
        //     const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEACTIVEDEACTIVE, {
        //         warehouse_id: id,
        //         action: newStatus,
        //     });
        //     if (res.data.response_code === 200) {
        //         fetchWareHouseData(selectedwarehouseData);
        //         toast.success(res.data.response_msg);
        //     } else {
        //         toast.error(res.data.response_msg || 'Failed to update status');
        //     }
        // } catch (error) {
        //     console.error('API error:', error);
        //     toast.error('Something went wrong');
        // }
    };
    const addStation = async (checked, id) => {
        setAddStationModal(true);
        // const newStatus = checked ? 1 : 0;
        // try {
        //     const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSEACTIVEDEACTIVE, {
        //         warehouse_id: id,
        //         action: newStatus,
        //     });
        //     if (res.data.response_code === 200) {
        //         fetchWareHouseData(selectedwarehouseData);
        //         toast.success(res.data.response_msg);
        //     } else {
        //         toast.error(res.data.response_msg || 'Failed to update status');
        //     }
        // } catch (error) {
        //     console.error('API error:', error);
        //     toast.error('Something went wrong');
        // }
    };
    const handleAddStationModal = (confirm) => {
        if (confirm) {
            handleAddStation();
            setAddStationModal(false);
        } else {
            setDeleteId(0);
            closeAddStationModal();
        }
    }

    const closeAddStationModal = () => {
        setAddStationModal(false);
    }
    const handleAddStation = async () => {
        // setAddStationModal(false);
        try {
            const res = await withRFSToken.post(ORGANIZATIONSTATIONADDEDIT, {
                org_station_id: selectedwarehouseData,
                station_id: selectedOrigin.station_id,
            });
            if (res.data.response_code === 200) {
                loadStation();
                setSelectedOrigin([]);
                toast.success(res.data.response_msg);
            } else {
                toast.error(res.data.response_msg || 'Failed to update status');
            }
        } catch (error) {
            console.error('API error:', error);
            toast.error('Something went wrong');
        }
    }
    const orgName = localStorage.getItem('OrgName')
    return (
        <>
            {isLoading ? <><div className='mvt loader-container h-100' style={{ background: '#f2f4ff', }}><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''}
            {!isLoading &&
                < div className="dashboard">
                    <Header page_type={authData?.org_type == 'H' ? 'handler' : (authData?.org_type == 'A' ? 'airline' : 'forwarder')} logo_url='/HandlerAdmin' /> {/* mode='SA'  */}
                    <div className="page-body-wrapper schedule">
                        <LeftMenu />
                        <div className="main-panel">
                            {/* {orgType === 'airlinetoken' && 
                        <>
                        <Link to='#' onClick={() => airlineCDM('RFS')}> RFS Control</Link> ||
                        <Link to='#' onClick={() => airlineCDM('ULD')}> ULD Control</Link>
                        </>
                        } */}
                            <div className="superAdmin_titleDv">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="dnata_title">
                                        <h4 className="mb-0">{userDetails?.org_name}</h4>
                                        <p className="mb-0"><img src={dnata_handeler_icon} alt="" className="pe-2" />Handler</p>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <div className="add_station_btn text-end">
                                            <Button variant="primary" onClick={() => addStation()}><span className="pe-2"><FontAwesomeIcon icon={faPlus} /></span>Add Station</Button>
                                        </div>
                                        <div class="msg_search_bx position-relative">
                                            <form class="d-flex">
                                                <div class="input-group position-relative">
                                                    <input class="form-control me-2 custom_input" type="search" placeholder="Search" onChange={handleSearch} aria-label="Search" />
                                                    <img src={search_icon} alt="" className="msg_search_icon" />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="admin_handler mt-3">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="super_admin_left">
                                            <div className="Attachment_dv">
                                                <div className="title d-flex justify-content-between align-items-center">
                                                    <h5>Attachment</h5>
                                                    <span className="ps-2 pe-3"><FontAwesomeIcon icon={faPlus} /></span>
                                                </div>
                                            </div>
                                            <div className="Support_ticket_list_Dv">
                                                <div className="ticket_list_title">
                                                    <h5>Support ticket list</h5>
                                                </div>
                                                <div className="super_ticket_list_wrap">
                                                    <div className="super_ticket_list">
                                                        <div className="top d-flex justify-content-between">
                                                            <span>ID: 1234586</span>
                                                            <span><FontAwesomeIcon icon={faEye} /></span>
                                                        </div>
                                                        <div className="bottom d-flex justify-content-between">
                                                            <span><FontAwesomeIcon icon={faUser} className="pe-2" />example@gmail.com</span>
                                                            <span>Jun 06, 2025</span>
                                                        </div>
                                                    </div>
                                                    <div className="super_ticket_list">
                                                        <div className="top d-flex justify-content-between">
                                                            <span>ID: 1234586</span>
                                                            <span style={{ color: 'rgba(40, 102, 194, 1)' }}><FontAwesomeIcon icon={faEye} /></span>
                                                        </div>
                                                        <div className="bottom d-flex justify-content-between">
                                                            <span><FontAwesomeIcon icon={faUser} className="pe-2" />example@gmail.com</span>
                                                            <span>Jun 06, 2025</span>
                                                        </div>
                                                    </div>
                                                    <div className="super_ticket_list">
                                                        <div className="top d-flex justify-content-between">
                                                            <span>ID: 1234586</span>
                                                            <span style={{ color: 'rgba(40, 102, 194, 1)' }}><FontAwesomeIcon icon={faEye} /></span>
                                                        </div>
                                                        <div className="bottom d-flex justify-content-between">
                                                            <span><FontAwesomeIcon icon={faUser} className="pe-2" />example@gmail.com</span>
                                                            <span>Jun 06, 2025</span>
                                                        </div>
                                                    </div>
                                                    <div className="super_ticket_list">
                                                        <div className="top d-flex justify-content-between">
                                                            <span>ID: 1234586</span>
                                                            <span style={{ color: 'rgba(40, 102, 194, 1)' }}><FontAwesomeIcon icon={faEye} /></span>
                                                        </div>
                                                        <div className="bottom d-flex justify-content-between">
                                                            <span><FontAwesomeIcon icon={faUser} className="pe-2" />example@gmail.com</span>
                                                            <span>Jun 06, 2025</span>
                                                        </div>
                                                    </div>
                                                    <div className="super_ticket_list">
                                                        <div className="top d-flex justify-content-between">
                                                            <span>ID: 1234586</span>
                                                            <span style={{ color: 'rgba(40, 102, 194, 1)' }}><FontAwesomeIcon icon={faEye} /></span>
                                                        </div>
                                                        <div className="bottom d-flex justify-content-between">
                                                            <span><FontAwesomeIcon icon={faUser} className="pe-2" />example@gmail.com</span>
                                                            <span>Jun 06, 2025</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-9">
                                        <div className="station_dv">
                                            <div className="row">
                                                {stationData?.map((data, index) => (
                                                    <div className="col-md-4">
                                                        <div className="station_nm">
                                                            <div className="station_top d-flex justify-content-between align-items-center">
                                                                <span><h5>{data.station_name}</h5></span>
                                                                <span>
                                                                    <span className="station_no_count">{data.total_warehouse}</span>
                                                                    <span className="wirehose_img"><img onClick={() => createWarehouse(data)} src={station_icon} alt="" /></span>
                                                                </span>
                                                            </div>
                                                            <div className="station_bottom d-flex justify-content-between align-items-center pt-2">
                                                                <Link to="#" onClick={() => handleUser(data)}>
                                                                    <span className="pe-2" style={{ color: 'rgba(157, 159, 166, 1)' }}><FontAwesomeIcon icon={faUser} /></span>
                                                                    <span>{data?.user_count}</span>
                                                                </Link>
                                                                <Button variant="primary" onClick={() => handleSwitch(data)} className="switch_btn"><img src={switch_icon} className="pe-2" />Switch</Button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal show={modalShow} onHide={modalClose} centered className='addfrom wire_house' size="lg">
                        <Modal.Header closeButton onClick={modalClose}>
                            {/* <Modal.Title>Create Warehouse</Modal.Title> */}
                        </Modal.Header>
                        <Modal.Body>
                            {showHideAddWareHouse === false ? (
                                <>
                                    <div className="wire_head">
                                        <h4>Warehouse List</h4>
                                        {/* <Link to='#' onClick={() => addWareHouseShowHide(true)}>+ Add</Link> */}
                                    </div>
                                    <Table className='uldlist'>
                                        <thead>
                                            <tr>
                                                <th>Action</th>
                                                <th>Warehouse Name</th>
                                                <th>Handler Name</th>
                                                <th>Handler Address</th>
                                                <th>Warehouse Type</th>
                                                <th>Warehouse Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {warehouselist?.map((data, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Link to="#" className="me-2"><img src={Edit} onClick={() => editWarehouse(data.id)} /></Link>
                                                        <Link to="#"><img src={Trash} onClick={() => deleteWarehouse(data.id)} /></Link>
                                                        {/* <Form.Check
                                                            type="switch"
                                                            id={`custom-switch-${data.id}`}
                                                            label=""
                                                            onChange={(e) => handleSwitchChange(e.target.checked, data.id)}
                                                            checked={data.status === 1}
                                                        /> */}
                                                    </td>
                                                    <td>{data.name}</td>
                                                    <td>{data.name_contains}</td>
                                                    <td>{data.address_contains}</td>
                                                    <td>{data.warehouse_type}</td>
                                                    <td>
                                                        <div>
                                                            <div class="form-check form-switch">
                                                                <input
                                                                    class="form-check-input switchActiveInactive door_switchActiveInactive"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    onChange={(e) => handleSwitchChange(e.target.checked, data.id)}
                                                                    checked={data.status === 1}
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))}

                                        </tbody>
                                    </Table>
                                    {/* {warehouselist?.map((data, index) => (
                                        <div key={index}>
                                            <div className="day-name">{data.name}</div>
                                        </div>
                                    ))} */}
                                    <p className="text-center">
                                        <Button variant="primary" onClick={() => addWareHouseShowHide(true)}>
                                            Add Warehouse
                                        </Button>
                                    </p>
                                </>
                            ) : (
                                <>
                                    <h3> Add Warehouse </h3>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Warehouse Name <span className="text-danger"> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            onChange={handleChange}
                                            name='warehouse_name'
                                            placeholder="Warehouse Name"
                                            value={warehouseData.warehouse_name}
                                        />
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Handler Name Contains <span className="text-danger"> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            onChange={handleChange}
                                            name='name_contains'
                                            placeholder="Handler Name Contains"
                                            value={warehouseData.name_contains}
                                        />
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Handler Address Contains <span className="text-danger"> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            onChange={handleChange}
                                            name='address_contains'
                                            placeholder="Handler Address Contains"
                                            value={warehouseData.address_contains}
                                        />
                                    </Form.Group>
                                    <Form.Group className='mb-2'>
                                        <Form.Label>Warehouse Type</Form.Label>
                                        <Form.Control
                                            type="text"
                                            onChange={handleChange}
                                            name='warehouse_type'
                                            placeholder="Warehouse Type"
                                            value={warehouseData.warehouse_type}
                                        />
                                    </Form.Group>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            {showHideAddWareHouse === true && (
                                <div className="d-flex w-75 mx-auto are_bottom">
                                    <Button variant="secondary" onClick={() => addWareHouseShowHide(false)} >
                                        Cancel
                                    </Button>
                                    <Button variant="primary" onClick={addWarehouse}>
                                        Save Warehouse
                                    </Button>
                                </div>
                            )}
                        </Modal.Footer>
                    </Modal>
                    <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
                        <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
                        <Modal.Body>
                            <h3>The Warehouse will be deleted. </h3>
                            <p>Are you sure you want to continue?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex w-50 mx-auto are_bottom">
                                <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
                                <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={addStationModal} onHide={closeAddStationModal} className="addfrom change_type" centered>
                        <Modal.Header closeButton onClick={closeAddStationModal}></Modal.Header>
                        <Modal.Body>
                            <>
                                <h3> Add Station </h3>
                                <Form.Label>Station List</Form.Label>
                                <Select
                                    options={getDestination}
                                    onChange={(selected) => {
                                        //const selectedIds = selected.map(item => item.value);
                                        // setSelectedOrigin(selectedIds);
                                        setSelectedOrigin(selected)
                                    }}
                                    placeholder="Origin"
                                    className='MultiSelect'
                                    name="origin"
                                    value={selectedOrigin}
                                />
                            </>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex w-50 mx-auto are_bottom">
                                <Button variant="secondary" onClick={() => handleAddStationModal(false)}> No</Button>
                                <Button variant="primary" onClick={() => handleAddStationModal(true)}> Yes </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                </div>
            }
        </>
    );

}
export default HandlerAdmin;